module.exports = __webpack_public_path__ + "assets/6b6d82a615a5e05ccb328e011119e323.png";